import { Entity, IField } from "@/app/fields/types";

export const fieldFilterApplied = <T extends Entity>(
  field: string,
  type: IField<T>["type"],
  searchParams: URLSearchParams
): boolean => {
  switch (type) {
    case "number":
      return (
        searchParams.get(`${field}__gte`) !== null ||
        searchParams.get(`${field}__lte`) !== null
      );
    case "date":
      return (
        searchParams.get(`${field}__start`) !== null ||
        searchParams.get(`${field}__end`) !== null
      );
    case "select":
    case "user":
    case "boolean":
      return !!searchParams.getAll(field).length;
    default:
      throw new Error(`Unknown filter type ${type}`);
  }
};
